import { ComponentProps, useCallback, useState } from 'react'
import { motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'

export function UnderlineMotion({
  children,
  className,
}: ComponentProps<'div'>) {
  const [width, setWidth] = useState<string>()

  const onHoverStart = useCallback(() => setWidth('100%'), [])

  const onHoverEnd = useCallback(() => setWidth(undefined), [])

  return (
    <motion.div
      className="relative max-w-fit cursor-pointer items-center"
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}>
      {children}
      <motion.div
        className={twMerge('absolute transition-all', className)}
        animate={{
          width,
          transition: {
            duration: 0.95,
            delay: 0.3,
          },
        }}
        style={{
          height: 0.8,
        }}
      />
    </motion.div>
  )
}
